import { render, staticRenderFns } from "./ProblemSolvingLeftSidebar.vue?vue&type=template&id=b6c11e24&"
import script from "./ProblemSolvingLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./ProblemSolvingLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports